module.exports = __webpack_public_path__ + "img/visa.738e0553.svg";